import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { withLatestFrom, filter, map } from 'rxjs/operators';
import { Action } from 'redux';
import { CreateOwnership, CreateOwnershipSuccess } from '../action-creators';
import AppState from '../../state';
import { NewOwnership } from '@services/ownership/types/new-ownership';
import { CREATE_OWNERSHIP_SUCCESS } from '../actions';
import { Ownership } from '@services/ownership/types/ownership';
import { ownersList } from '../selectors';

/**
 *
 * This effect creates a owner after a successful Songwriter Creation
 *
 */

export const createOwnerForSongwriter = (action$: Observable<Action>, state$: StateObservable<AppState>) =>
  action$.pipe(
    ofType<Action, CreateOwnershipSuccess>(CREATE_OWNERSHIP_SUCCESS),
    withLatestFrom(state$),
    filter(([action, state]) => action.ownership.ownershipType === 'WRITER' && isWriterMissing(state, action.ownership)),
    map(([action, _state]) => {

      const newOwner: NewOwnership = {
        assetId: action.ownership.assetId,
        assetType: 'TRACK',
        ownershipType: 'OWNER',
        name: action.ownership.name,
        contact: action.ownership.contact,
        contactType: action.ownership.contactType,
        ownerType: action.ownership.ownerType,
        ownerId: action.ownership.ownerId,
        split: 0,
        order: action.ownership.order
      }

      return new CreateOwnership(newOwner);
    })
  );

  const isWriterMissing = (state: AppState, newOwner: Ownership): boolean => {
    const currentOwners = ownersList(state.ownership, newOwner.assetId);

    const found = currentOwners.find((owner) => {
      return (
        owner.contact === newOwner.contact
      ) || (
        owner.ownerId && owner.ownerId === newOwner.ownerId
      );
    });

    return !found;
  }